import ReactGA from "react-ga4";
import { REACT_APP_GOOGLE_ANALYTICS_TOGGLE, REACT_APP_GOOGLE_ANALYTICS } from "../../config";

const GA4_ENABLED = REACT_APP_GOOGLE_ANALYTICS_TOGGLE && !!REACT_APP_GOOGLE_ANALYTICS;

const executeIfEnabled = (fn) => {
  return (...args) => {
    if (GA4_ENABLED) {
      return fn(...args);
    }
  };
};

export const googleAnalyticsInit = executeIfEnabled(() => {
  const measurementId = REACT_APP_GOOGLE_ANALYTICS;

  if (!measurementId) {
    console.warn("Google Analytics Measurement ID not found in environment variables");
    return;
  }

  return ReactGA.initialize(measurementId);
});

export const eventPickupScheduled = executeIfEnabled(() => {
  return ReactGA.event({
    category: "Pickup",
    action: "scheduled",
  });
});

export const eventCustom = executeIfEnabled((category, action, label = null, value = null) => {
  const eventData = {
    category,
    action,
  };

  if (label) eventData.label = label;
  if (value !== null) eventData.value = value;

  return ReactGA.event(eventData);
});

// Typo preserved for backward compatibility
export const eventCustome = eventCustom;

/**
 * Send page view to Google Analytics 4
 * @param {string} path - Page path
 * @param {string} title - Page title (optional)
 */
export const sendPageView = executeIfEnabled((path, title) => {
  // Send page view using react-ga4
  ReactGA.send({
    hitType: "pageview",
    page: path,
    title: title,
  });
});
